import Box from "@mui/material/Box";
import React from "react";

interface ITabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const TabPanel: React.FC<ITabPanelProps> = (props) => {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
			style={{height: "100%"}}
		>
			{value === index && (
				<Box sx={{ p: 3, width: "100%", height: "100%" }}>
					{children}
				</Box>
			)}
		</div>
	);
};
